@import '../../../globals/main.scss';

pn-cta-block {
  display: flex;
  justify-content: center;

  .cta-block {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    border-radius: 2.4rem;
    padding: 3.2rem 2.4rem;
    width: 100%;

    @media screen and (min-width: $min-width-md) {
      flex-direction: row;
      padding: 2.4rem;
    }

    @media screen and (min-width: $max-width-xl) {
      margin-right: auto;
      margin-left: auto;
      max-width: 95%;
    }

    @media screen and (min-width: $max-width-xxl) {
      max-width: 90%;
    }

    &[pn-background-color='blue25'] {
      background-color: $blue25;
    }

    &[pn-background-color='coral50'] {
      background-color: $coral50;
    }

    &[pn-background-color='gray25'] {
      background-color: $gray25;
    }

    &[pn-background-color='green25'] {
      background-color: $green25;
    }

    &[pn-background-color='transparent'] {
      padding: 0 3.2rem;
    }
  }

  .cta-block--content-top {
    .cta-block__content {
      justify-content: flex-start;
    }
  }

  .cta-block--large {
    .cta-block__heading {
      @media screen and (min-width: $min-width-md) {
        font-size: 3.6rem;
      }
    }

    .cta-block__text {
      @media screen and (min-width: $min-width-md) {
        font-size: 2rem;
      }
    }
  }

  .cta-block--small {
    width: auto;

    @media screen and (min-width:$min-width-lg) {
      display: inline-flex;
      max-width: 75%;

      &.cta-block--center {
        max-width: 66%;
      }
    }
  }

  .cta-block--center {
    align-items: center;
    flex-direction: column;
    gap: 1.6rem;
    text-align: center;

    @media screen and (min-width:$min-width-md) {
      gap: 2.4rem;
      padding: 3.2rem;
    }

    .cta-block__content {
      @media screen and (min-width: $min-width-md) {
        max-width: 74rem;
        padding: 0;
      }
    }

    .cta-block__action {
      margin-top: 0.8rem;

      &>[slot='cta-button'] {
        gap: 0.8rem;
      }

      @media screen and (min-width: $min-width-md) {
        flex-direction: row;
        gap: 2.4rem;
        margin-top: 1.6rem;

        &.cta-block__button {
          margin-bottom: 0;
        }

        &>[slot='cta-buttons'] {
          flex-direction: row;
          align-items: center;
          gap: 2.4rem;
        }
      }
    }

    .cta-block__image-wrapper {
      @media screen and (min-width: $min-width-md) {
        display: block;
      }

      & > [slot='illustration'] {
        padding-right: 0;
      }
    }

    .cta-block__text {
      margin-bottom: 0 !important;
    }
  }

  .cta-block__image-wrapper {
    margin-bottom: 1.6rem;

    &>[slot='illustration'] {
      &>picture>img {
        border-radius: 0.8rem;
        max-width: 100%;
      }
    }

    @media screen and (min-width:$min-width-md) {
      display: none;
      max-width: 20%;
    }

    @media screen and (min-width: $min-width-lg) {
      display: block;
      margin-bottom: 0;

      & > [slot='illustration'] {
        padding-right: 3.2rem;
      }
    }
  }

  .cta-block__content {
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;

    @media screen and (min-width: $min-width-md) {
      padding-right: 2.4rem;
    }

    .cta-block__heading,
    .cta-block__text {
      @media screen and (min-width: $min-width-md) {
        max-width: 74rem;
        text-wrap: balance;
      }
    }

    .cta-block__text {
      margin-bottom: 2.4rem;

      @media screen and (min-width: $min-width-md) {
        margin-bottom: 0;
      }
    }
  }

  .cta-block__heading {
    margin-bottom: 0.8rem;
  }

  .cta-block__action {
    display: flex;

    &>[slot='cta-buttons'] {
      display: flex;
      flex-direction: column;
      row-gap: 1.6rem;
      flex: 1;

      @media screen and (min-width:$min-width-md) {
        align-items: flex-end;
        justify-content: center;
        gap: 1.6rem;
        margin-top: 0;
      }

      & > a {
        color: $blue700;
        font-weight: 500;
        font-size: 1.6rem;
        padding: 0.1rem;
        text-decoration: none;

        pn-icon svg {
          transition: transform 0.3s ease-in-out;

          path {
            fill: $blue700;
          }
        }

        &:hover {
          color: $blue900;
          text-decoration: underline;
          
          pn-icon svg {
            transition: transform 0.3s ease-in-out;
            transform: translateX(0.3rem);

            path {
              fill: $blue900;
            }
          }
        }
      }
    }
  }
}
